// Shared mobile utilities for all components
import { useState, useEffect } from 'react';

// Hook to detect mobile screen
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return isMobile;
};

// Mobile styles helper
export const mobileStyles = {
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '1rem',
    marginBottom: '0.75rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    border: '1px solid #E2E8F0',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem',
  },
  cardTitle: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#1E293B',
  },
  cardMeta: {
    fontSize: '0.75rem',
    color: '#64748B',
  },
  pageTitle: {
    fontSize: '1.25rem',
  },
  tabsContainer: {
    display: 'flex',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    gap: '0.4rem',
    paddingBottom: '0.5rem',
    marginLeft: '-1rem',
    marginRight: '-1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  },
  tabButton: {
    fontSize: '0.75rem',
    padding: '0.4rem 0.6rem',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
};
